(ns frontend.view.modals.curtains.sales-opportunity.on-hold-curtain
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [ui.editors.data-input :as data-input]
   [ui.editors.labelled-input.view :as labelled-input]
   [frontend.view.modals.curtains.sales-opportunity.events :as events]
   [ui.color :as c]
   [ui.components.modal.view :as modal]))

(defonce modal-key :curtain.sales-opportunity/put-on-hold)

(defonce preset-months [1 2 3 6 12])

(defn month-selector
  [edit-state _state-atom]
  (let [attribute :months
        value (get @edit-state attribute)
        options (concat (->> preset-months
                             (map (fn [num]
                                    {:value   num
                                     :label (if (= num 1)
                                              (loc/tr :month-one)
                                              (loc/tr :months-num [num]))})))
                        [{:value  0
                          :label (loc/tr :select-custom-date)}])]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :label (loc/tr :until)
       :mandatory?         true
       :options options
       :value (->> options
                   (cu/filter-by :value value)
                   (first))
       :on-change (fn [selected-value _selected-option]
                    (if (nil? selected-value)
                      (swap! edit-state dissoc attribute selected-value)
                      (swap! edit-state assoc attribute selected-value)))}]]))

(defn until-selector
  [edit-state _state-atom]
  (let [attribute :until
        value (get @edit-state attribute)]
    [:div
     [data-input/view
      {:data-type   :data.type/datetime
       :placeholder (loc/tr :select-date)
       :full-width? true
       :value       value
       :on-change   (fn [utc-ms]
                      (swap! edit-state assoc attribute utc-ms))}]]))

(defn internal-comment-input
  [edit-state _state-atom _sales-opportunity]
  (let [attribute :internal-comment
        value (get @edit-state attribute)]
    [:div
     [labelled-input/view
      {:label (loc/tr :put-on-hold-curtain/internal-comment)
       :data-type :data.type/text-multiline
       :value value
       :on-change (fn [new-value]
                    (if (nil? new-value)
                      (swap! edit-state dissoc attribute new-value)
                      (swap! edit-state assoc attribute new-value)))}]]))

(defn view
  [{:keys [_shown? _topmost? _close-modal! _props state _class-name]}]
  (let [edit-state (r/cursor state [:edit])
        state-atom (r/cursor state [:state-atom])]
    (fn [{:keys [shown? topmost? close-modal! props state _class-name]}]
      (let [{:keys [sales-opportunity-id reset-focus!]} props
            session-entities @session/entities
            sales-opportunity (get session-entities sales-opportunity-id)
            sales-opportunity-name (:sales-opportunity/name sales-opportunity)
            header-text (loc/tr :put-on-hold-curtain/title [sales-opportunity-name])
            edit-vals @edit-state
            {:keys [months until]} edit-vals
            close-modal! (fn []
                           (close-modal!)
                           (when reset-focus!
                             (reset-focus!)))
            button-disabled? (or (not (some #{months} (conj preset-months 0)))
                                 (and (zero? months)
                                      (nil? until)))
            ;; tooltip (when error-text
            ;;           (r/as-element [rbs/Tooltip
            ;;                          {:class "in modal-tooltip"
            ;;                           :id    "put-on-hold-error-tooltip"}
            ;;                          error-text]))
            ]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/warning
          :close-button? true}
         [:<> [:i.fal.fa-pause-circle.mr-2]
          header-text]
         [:div
          {:class "flex flex-col gap-4"}
          [month-selector edit-state state-atom]
          (when (zero? months)
            [until-selector edit-state state-atom])
          [internal-comment-input edit-state state-atom sales-opportunity]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/warning
           button-disabled?
           #(events/confirm-on-hold state sales-opportunity close-modal!)
           (loc/tr :sales-opportunity.put-on-hold-curtain/put-on-hold)
           nil]]]))))
